import { createRoute } from '@tanstack/react-router'
import { appShellRoute } from '@/app/routes/_appShell'
import { validatePaginatedSearch } from '@/app/routes/_search'
import { RankingPage } from '@/features/ranking/pages/RankingPage'

export const rankingRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/ranking',
  validateSearch: validatePaginatedSearch,
  component: RankingPage,
})
